import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appInputMaxLength]',
  standalone: true
})
export class InputMaxLengthDirective {
  @Input() public appInputMaxLength: number;

  constructor(private elementRef: ElementRef) {}

  @HostListener('input', ['$event.target.value'])
  public onChange(value): void {
    if (value.length >= this.appInputMaxLength) {
      const newValue = value.substr(0, this.appInputMaxLength);
      value = newValue;
    }
  }
}
